import React from 'react';
import { observer } from 'mobx-react-lite';
import { FilterDropdown } from 'components/common/general/CollectionManagementPanel/FilterDropdown';
import { useRFQProductTemplatesStore } from 'store/pages/rfq/rfq-template/rfq-product-templates/pageStore';
import { PRODUCT_TEMPLATES_FILTERS } from '../../constants';

export const StateFilterDropdown: React.FC = observer(() => {
  const {
    paginationDelegate: { filters, setFilterValue },
    availableStates,
  } = useRFQProductTemplatesStore();

  const stateOptions = availableStates.map((stateValue) => ({
    value: stateValue,
    label: stateValue,
  }));

  const onApplyFilter = (value: string | null): void => {
    if (value) {
      setFilterValue('state', value);
    }
  };

  return (
    <FilterDropdown
      filterName="State"
      $minWidth="20rem"
      optionsWidth="20rem"
      selectedFilterLabel={filters.state}
      filtersList={stateOptions}
      applyFilter={onApplyFilter}
      data-test-id={PRODUCT_TEMPLATES_FILTERS.STATE_FILTER_DROPDOWN_TEST_ID}
    />
  );
});
